/**
 * The envelope only guarantees `description`; the code may arrive under any of
 * the keys the backend slices use today, so probe them all rather than guess.
 */
export function apiErrorCode(err: unknown): string | null {
  const body = (err as { error?: Record<string, unknown> } | null)?.error;
  if (!body) return null;
  const code = body['code'] ?? body['errorCode'] ?? body['error'];
  return typeof code === 'string' ? code : null;
}
